// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__26yS9","content":"styles_content__1ic0j","checkbox":"styles_checkbox__1P5lU","checkboxLabel":"styles_checkboxLabel__zI1X2"};